import { LinearProgress } from '@mui/material'
import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'

export const AudioMediaPlayerWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  alignItems: 'center',
})

export const AudioMediaConrolsWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  paddingTop: '12px',
  gap: '16px',
  marginBottom: '8px',

  '& .MuiBox-root': {
    width: '25px',
    height: '25px',
    cursor: 'pointer',

    svg: {
      fontSize: '25px',
    },
  },
})

export const AudioMediaProgressWrapper = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',

  '& .call-timer': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',

    '& .MuiTypography-root': {
      fontSize: '10px',
      lineHeight: '14px',
      fontWeight: 400,
      color: theme.palette.text.secondary,
    },
  },
}))

export const ProgressWrapper = styled(LinearProgress)({
  borderRadius: '2px',
  backgroundColor: '#E6E8ED',
  height: '4px',
  marginBottom: '8px',
})
